import { ButtonGroup, modals, Button } from '@cad-arc';

export function showAssignAndHoldConfirmationModal({
    title = 'Assign Units',
    body,
    onAssignAndHold,
    onAssignOnly,
    cancelButtonRef,
}: {
    title?: string;
    body: JSX.Element;
    onAssignAndHold: () => void;
    onAssignOnly: () => void;
    cancelButtonRef: React.MutableRefObject<HTMLButtonElement | null>;
}): void {
    modals.modal({
        initialFocusRef: cancelButtonRef,
        title,
        body,
        footer: (props) => (
            <ButtonGroup>
                <Button
                    ref={cancelButtonRef}
                    onClick={() => {
                        props.onClose();
                    }}
                    variant="ghost"
                >
                    Cancel
                </Button>
                <Button
                    onClick={() => {
                        onAssignOnly();
                        props.onClose();
                    }}
                >
                    Assign Only
                </Button>
                <Button
                    onClick={() => {
                        onAssignAndHold();
                        props.onClose();
                    }}
                    variant="solid"
                >
                    Assign and Hold
                </Button>
            </ButtonGroup>
        ),
    });
}
